var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loaded)?_c('LanguageDropdown',{attrs:{"selectedLang":_vm.selectedLang,"containerClasses":_vm.containerClasses},on:{"languageIsSelected":_vm.languageIsSelected}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }